import Call from '../Call';

const Messages = {
    getNames() {
        return Call('messages/names');
    }
}

export default Messages;


// WEBPACK FOOTER //
// ./src/services/API/components/Messages.js